export default __webpack_public_path__ + "4eabddab32e067aa7e184302142c2ce7.svg";